import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { Config } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

export default function TextsForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Config>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <WysiwygField
        label="Testo homepage"
        rows={12}
        layout="horizontal"
        value={values?.testo_homepage ?? ""}
        onChange={(value) => {
          setFieldValue("testo_homepage", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "testo_homepage") : undefined}
        errorMessage={getIn(errors, "testo_homepage")}
      />
      <WysiwygField
        label="Testo pagina cipec"
        rows={12}
        layout="horizontal"
        value={values?.testo_cipec ?? ""}
        onChange={(value) => {
          setFieldValue("testo_cipec", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "testo_cipec") : undefined}
        errorMessage={getIn(errors, "testo_cipec")}
      />
    </Col>
  )
}
